module.exports = __webpack_public_path__ + "static/media/coins-mail-icon.03bebee4.png";